import React, { useState } from 'react';
import { FiCheck } from 'react-icons/fi';

interface ICheckboxProps {
  label: string;
  initialChecked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

const AppCheckbox = ({
  label,
  initialChecked = false,
  onChange,
  className,
}: ICheckboxProps) => {
  const [checked, setChecked] = useState(initialChecked);

  const handleChange = (e: any) => {
    setChecked(e.target.checked);
    if (onChange) onChange(e.target.checked);
  };

  return (
    <div className={`flex gap-2 items-center ${className}`}>
      <label className="relative flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          className="hidden"
        />
        <span
          className={`w-5 h-5 flex items-center justify-center rounded border ${
            checked
              ? 'bg-gray-950 border-gray-950 text-white'
              : 'bg-white border-gray-300'
          }`}
        >
          {checked && <FiCheck />}
        </span>
      </label>
      <p className="text-sm font-semibold">{label}</p>
    </div>
  );
};

export default AppCheckbox;
